import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { TelefonoService } from './services/telefono.service';
import { ITelefono, ITelefonoRequest, ITelefonoResponse } from './interfaces/telefono.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-lista-telefonos',
  templateUrl: './lista-telefonos.component.html',
  providers: [MessageService]
})
export class ListaTelefonosComponent implements OnInit {
  @ViewChild('dt') table!: Table;

  displayDialog: boolean = false;
  selectedTelefono: ITelefono | null = null;
  dataSource: ITelefono[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  displayedColumns = [
    { field: 'telefono', header: 'Teléfono', sortable: true },
    { field: 'nombres', header: 'Nombres', sortable: true },
    { field: 'tipoTelefono', header: 'Tipo Teléfono', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private telefonoService: TelefonoService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    const request: ITelefonoRequest = {
      que: 4,
      tope: "9999",
      telefono: '',
      primer_nombre: '',
      segundo_nombre: '',
      apellido_paterno: '',
      apellido_materno: '',
      calle: '',
      nombre_empresa: '',
      numero_ext: '',
      boletinado: '',
      tipoTelefono: ''
    };

    this.telefonoService.getTelefonos(request).subscribe({
      next: (response: ITelefonoResponse) => {
        if (response.success) {
          this.dataSource = response.data;
          this.totalRecords = response.data.length;
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudieron cargar los teléfonos'
          });
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al cargar los teléfonos'
        });
        console.error('Error:', error);
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  openCreate(): void {
    this.selectedTelefono = null;
    this.displayDialog = true;
  }

  openUpdate(row: ITelefono): void {
    this.selectedTelefono = { ...row };
    this.displayDialog = true;
  }

  openDelete(row: ITelefono): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este teléfono?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        this.telefonoService.deleteTelefono(row.telefono).subscribe({
          next: (response) => {
            if (response.success) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Teléfono eliminado correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al eliminar el teléfono'
              });
            }
          },
          error: (error) => {
            console.error('Error:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Error al eliminar el teléfono'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }

  onDialogClosed(): void {
    this.selectedTelefono = null;
    this.displayDialog = false;
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onSave(result: { success: boolean; message: string }): void {
    if (result?.success) {
      this.messageService.add({
        severity: 'success',
        summary: 'Éxito',
        detail: result.message
      });
    }
    this.displayDialog = false;
    this.loadData();
  }

  // Método para obtener nombres completos
  getNombresCompletos(row: ITelefono): string {
    const nombres = [
      row.primer_nombre,
      row.segundo_nombre,
      row.apellido_paterno,
      row.apellido_materno
    ].filter(nombre => nombre && nombre.trim() !== '');
    
    return nombres.join(' ');
  }
} 